export default __webpack_public_path__ + "ce06b80d07bcf0df0ed97a9ce11f9f22.svg";